import React from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useChatHandlers } from '../hooks/useChatHandlers';

const StyledButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.error.main,
}));

const StartNewChat: React.FC = () => {
  const { handleClearMessages } = useChatHandlers();

  return (
    <Tooltip title="Neuen Chat starten / Chat zurücksetzen">
      <StyledButton onClick={handleClearMessages}>
        <RestartAltIcon />
      </StyledButton>
    </Tooltip>
  );
};

export default StartNewChat;